var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('router-view')],1),_c('ImagePreviewDialog'),_c('v-snackbar',{attrs:{"color":_vm.networkColor,"top":"","right":"","timeout":"3000","elevation":"6"},model:{value:(_vm.showNetworkSnack),callback:function ($$v) {_vm.showNetworkSnack=$$v},expression:"showNetworkSnack"}},[_vm._v(" "+_vm._s(_vm.networkMessage)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }